














import Vue from 'vue'
import Component from 'vue-class-component'
import MediaViewer from '@/modules/media/components/MediaViewer.vue'
import {Watch} from 'vue-property-decorator'
import {Route} from 'vue-router'
import {Colors, notify} from '@/modules/core/notification'
import Loader from '@/components/Loader.vue'

/**
 * Muestra el visor multimedia en un dialogo
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {Loader, MediaViewer},
})
export default class MediaViewerDialog extends Vue {
    public loading = false

    /**
     * Observa la ruta actual y carga el objeto multimedia
     *
     * @param route
     */
    @Watch('$route', {immediate: true})
    public async watchRoute (route: Route) {
        this.loading = true
        const { id } = route.params
        // El id es obligatorio
        if (!id) {
            notify('El id del archivo es obligatorio', Colors.Error)
            await this.$router.back()
            this.loading = false
        }

        await this.$store.dispatch('media/loadMediaObject', parseInt(id, 10))
        this.loading = false
    }
}
